
import service from "../services/productionPayments.service"; // Asegúrate de que el servicio esté configurado correctamente

export const productionPayments = {
    namespaced: true,
    state: {
        data: [],
        currentPage: 1,
        lastPage: 1,
        links:[],
        getData:[],
        loading: false,
    },
    getters: {
        allData: (state) => state.data,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
        }),
        links: (state) => state.links,
        getData: (state) => state.getData,
        loading: (state) => state.loading,
    },
    actions: {
        async fetchData({ commit },pageUrl = null) {
            try {
                commit('SET_LOADING', true);
                commit('CLEAR_DATA'); // Limpiar datos antes de cargar nuevos
                const response = await service.getAll(pageUrl); 

                commit('SET_DATA', response.data.data); 
                commit('SET_PAGINATION', {
                    currentPage: response.data.current_page,
                    lastPage: response.data.last_page,
                    links: response.data.links, // Agrega los links de paginación aquí
                });
            } catch (error) {
                console.error("Error fetching proyects:", error);
            } finally {
                commit('SET_LOADING', false);
            }
        },
        async save(context,data) {
            try {
                let response;
                if(data.id===0){
                    response = await service.createData(data);
                }else{
                    response = await service.updateData(data.id,data);
                }  
               
                return response; 
            } catch (error) {
                console.error("Error save projects:", error);
                return error.response; 
            }
        },
        async delete({ commit }, userId) {
            try {
                const response = await service.deleteData(userId);
                commit('REMOVE_DATA', userId); // Asegúrate de tener una mutación para eliminar el usuario de la lista
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response; ; // Propaga el error para que sea manejado en el componente
            }
        },
        async getData({ commit }, id) {
            try {
                const response = await service.getData(id);
                commit('SET_GET_DATA', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getAll() {
            try {
                const response = await service.getAll({page:'all'});
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getPdf(context, id) {
            try {
                const response = await service.getPdf(id);
                return response;
            } catch (error) {
                console.error("Error fetching PDF:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_DATA(state, data) {
            state.data = data;
        },
        CLEAR_DATA(state) {
            state.data = [];
        },
        SET_PAGINATION(state, pagination) {
            state.currentPage = pagination.currentPage;
            state.lastPage = pagination.lastPage;
            state.links = pagination.links;
        },
        ADD_DATA(state, data) {
            state.data.push(data); // Agrega el nuevo usuario al array de usuarios
        },
        SET_GET_DATA(state, data) {
            state.getData = data;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        REMOVE_DATA(state, id) {
            state.data = state.data.filter(item => item.id !== id);
        }
    },
};